"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;
var svgElements = 'svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]';
var iframeAttrs = ['id', 'accesskey', 'class', 'dir', 'lang', 'style', 'tabindex', 'title', 'role', 'allow', 'contenteditable', 'contextmenu', 'draggable', 'dropzone', 'hidden', 'spellcheck', 'translate', 'xml:lang', 'src', 'name', 'width', 'height', 'longdesc', 'frameborder', 'marginwidth', 'marginheight', 'scrolling', 'align', 'sandbox', 'seamless', 'allowfullscreen'];
var iframeSchema = "iframe[" + iframeAttrs.join('|') + "]";
var blockContent = 'address|figure|blockquote|div|dl|fieldset|form|h1|h2|h3|h4|h5|h6|hr|menu|ol|p|pre|table|ul';
var removeformat = [{
  selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
  remove: 'all',
  split: true,
  expand: false,
  block_expand: true,
  deep: true
}, {
  selector: 'span',
  attributes: ['style', 'class'],
  remove: 'empty',
  split: true,
  expand: false,
  deep: true
}, {
  selector: '*:not(.mce-token)',
  attributes: ['style', 'class'],
  split: false,
  expand: false,
  deep: true
}, {
  selector: 'img',
  attributes: ['align'],
  remove: 'empty',
  split: false,
  expand: false,
  deep: false
}, {
  selector: 'img.mce-token',
  styles: {
    margin: 'auto',
    'margin-left': 'auto',
    'margin-right': 'auto'
  },
  remove: 'none',
  split: false,
  expand: false,
  deep: false
}];
var settings = {
  mode: 'exact',
  preview_styles: false,
  // Default URL settings
  convert_urls: false,
  relative_urls: false,
  remove_script_host: false,
  // don't allow script tags in content
  allow_script_urls: false,
  // image plugin options
  image_menu_context: 'insert',
  image_prepend_to_context: true,
  //  this can be used to disable our tweaks to the image plugin to use the file manager
  withoutFileManager: false,
  // media (video) plugin options
  media_menu_context: 'insert',
  media_prepend_to_context: true,
  media_alt_source: false,
  media_poster: false,
  // new in 4.3
  media_live_embeds: false,
  // hslink plugin options
  hslink_show_other_options: true,
  hslink_url_formatter: function hslink_url_formatter(ed, url) {
    return url;
  },
  hslink_show_pages_dropdown: false,
  // hspersonalize plugin options
  hspersonalize_enable_deal_tokens: false,
  hspersonalize_enable_deal_tokens_warning: false,
  // ecommerce specific deal token warning
  hspersonalize_enable_deal_ticket_tokens_warning: false,
  // general dea/ticket token warning
  hspersonalize_enable_ticket_tokens: false,
  // contextmenu plugin options
  contextmenu: 'link image inserttable | cell row column deletetable',
  // Allow text to be at the document root,
  // but force paragraphs on carriage return
  forced_root_block: false,
  force_p_newlines: true,
  // allow any attribute on common layout tags
  extended_valid_elements: "#p[*],a[*],span[*],img[*],#div[*],section[*],i[*],blockquote[*],address[*],blockquotespan[*],script[*],video[*],table[*]," + iframeSchema + "," + svgElements,
  valid_children: "+a[" + blockContent + "}]",
  custom_elements: '~svg',
  statusbar: false,
  table_toolbar: false,
  formats: {
    removeformat: removeformat
  },
  // Prevent tinyMCE from breaking IE/Outlook conditional comments
  // by inserting a space before the [if ...]
  protect: [/<!--\[.*?\]>[\s\S]*?<!\[.*?\]-->/g],
  table_default_attributes: {
    border: '0'
  }
};
exports.settings = settings;